export default "__VITE_ASSET__DmClpo1O__"